// extracted by mini-css-extract-plugin
export default {"auth":"Login_auth__Z7XOa","control":"Login_control__SgCK9","actions":"Login_actions__Cvd+Z"};